export default {"src":"/_next/static/media/checkmark-square-active.35badd1a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};